import React from "react";

export const PrimaryServices = () => {
  const services = [
    {
      title: "Carné Virtual",
      description: "Visualiza tu carné de conducir digital",
      url: "https://consultas.kalelsac.com/",
      icon: "🆔",
      color: "#3498db"
    },
    {
      title: "Aula Virtual",
      description: "Accede a nuestros cursos en línea",
      url: "https://aulavirtual.kalelsac.com/",
      icon: "🎓",
      color: "#e74c3c"
    },
    {
      title: "Reservar Cita",
      description: "Agenda tu cita para evaluación",
      url: "https://ceval.kalelsac.com/citas",
      icon: "📅",
      color: "#2ecc71"
    },
    {
      title: "Simulacro de Examen",
      description: "Practica para tu examen de brevete",
      url: "https://evaluacion.kalelsac.com/login",
      icon: "📝",
      color: "#f39c12"
    }
  ];

  const handleServiceClick = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div id="primary-services" style={{
      padding: '80px 0',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Elementos decorativos de fondo */}
      <div style={{
        position: 'absolute',
        top: '-50px',
        right: '-50px',
        width: '200px',
        height: '200px',
        background: 'rgba(255,255,255,0.1)',
        borderRadius: '50%',
        zIndex: 1
      }}></div>
      <div style={{
        position: 'absolute',
        bottom: '-100px',
        left: '-100px',
        width: '300px',
        height: '300px',
        background: 'rgba(255,255,255,0.05)',
        borderRadius: '50%',
        zIndex: 1
      }}></div>
      
      <div className="container" style={{ position: 'relative', zIndex: 2 }}>
        <div className="row">
          <div className="col-xs-12 col-md-6 col-md-offset-3">
            <div className="section-title" style={{ textAlign: 'center', marginBottom: '60px' }}>
              <h2 style={{ 
                color: 'white', 
                fontSize: '3em', 
                fontWeight: 'bold',
                textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
                marginBottom: '20px'
              }}>
                Servicios Principales
              </h2>
              <p style={{ 
                color: 'rgba(255,255,255,0.9)', 
                fontSize: '1.2em',
                textShadow: '1px 1px 2px rgba(0,0,0,0.3)'
              }}>
                Accede rápidamente a nuestros servicios más importantes
              </p>
            </div>
          </div>
        </div>
        
        <div className="row">
          {services.map((service, index) => (
            <div key={index} className="col-xs-12 col-sm-6 col-md-3" style={{ marginBottom: '30px' }}>
              <div 
                onClick={() => handleServiceClick(service.url)}
                style={{
                  background: 'white',
                  borderRadius: '20px',
                  padding: '30px 20px',
                  textAlign: 'center',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
                  border: `3px solid ${service.color}`,
                  position: 'relative',
                  overflow: 'hidden'
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'translateY(-10px)';
                  e.target.style.boxShadow = '0 20px 40px rgba(0,0,0,0.3)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 10px 30px rgba(0,0,0,0.2)';
                }}
              >
                {/* Efecto de brillo en hover */}
                <div style={{
                  position: 'absolute',
                  top: 0,
                  left: '-100%',
                  width: '100%',
                  height: '100%',
                  background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent)',
                  transition: 'left 0.5s ease'
                }}></div>
                
                <div style={{
                  fontSize: '4em',
                  marginBottom: '15px',
                  filter: 'drop-shadow(2px 2px 4px rgba(0,0,0,0.1))'
                }}>
                  {service.icon}
                </div>
                
                <h3 style={{
                  color: service.color,
                  fontSize: '1.4em',
                  fontWeight: 'bold',
                  marginBottom: '10px'
                }}>
                  {service.title}
                </h3>
                
                <p style={{
                  color: '#666',
                  fontSize: '0.95em',
                  lineHeight: '1.4',
                  marginBottom: '20px'
                }}>
                  {service.description}
                </p>
                
                <div style={{
                  display: 'inline-block',
                  background: service.color,
                  color: 'white',
                  padding: '8px 20px',
                  borderRadius: '25px',
                  fontSize: '0.9em',
                  fontWeight: 'bold',
                  transition: 'all 0.3s ease'
                }}>
                  Acceder →
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="row" style={{ marginTop: '40px' }}>
          <div className="col-xs-12" style={{ textAlign: 'center' }}>
            <p style={{
              color: 'rgba(255,255,255,0.8)',
              fontSize: '1em',
              fontStyle: 'italic'
            }}>
              Todos nuestros servicios están disponibles las 24 horas del día
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};